// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cdc98e81d64aac079 {\r\n    color: var(--color-orange);\r\n    stroke: var(--color-orange);\r\n    width: 50px;\r\n}", "",{"version":3,"sources":["webpack://./src/Components/LoadIndicator.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,WAAW;AACf","sourcesContent":[".loadIndicator {\r\n    color: var(--color-orange);\r\n    stroke: var(--color-orange);\r\n    width: 50px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadIndicator": "cdc98e81d64aac079"
};
export default ___CSS_LOADER_EXPORT___;
